import restApi from "@plannel/services/utils/rest-api";

const getAll = (params) => {
  return restApi.post("/api/calendar-groups", params);
};

const getAllForCSV = params => {
  return restApi.post("/api/calendar-groups/csv", params);
};

const get = name => {
  return restApi.get(`/api/calendar-group/${name}`);
};

const upsert = data => {
  return restApi.post("/api/calendar-groups/save", data);
};

const remove = ids => {
  return restApi.delete(`/api/calendar-groups/${ids}`);
};

const calendarGroupService = {
  getAll,
  getAllForCSV,
  get,
  upsert,
  remove
};

export default calendarGroupService;